import { useEffect } from 'react';

export default ({ handler }) => {
  useEffect(() => {
    const handleEvent = event => handler(event);
    window.addEventListener('message', handleEvent);
    return () => window.removeEventListener('message', handleEvent);
  }, []);

  return null;
};
